import { useState, useMemo } from "react";
import { RxCross2 } from "react-icons/rx";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { FaArrowAltCircleRight } from "react-icons/fa";

const ViewImageModal = ({ images, setOpenModal, url }) => {
  const [isOpen, setIsOpen] = useState(true);
  const imageId = useMemo(() => {
    const ans = images?.map((item, index) => ({
      url: item,
      id: index,
    }));
    return ans?.find((item) => item?.url === url)?.id;
  }, []);
  const [id, setImageId] = useState(imageId);

  const handleClose = (e) => {
    if (e.target.id === "overlay") {
      setIsOpen(false);
      setOpenModal(false);
    }
  };

  const handleCloseModal = (e) => {
    setIsOpen(false);
    setOpenModal(false);
  };

  const handleNext = () => {
    setImageId(id + 1);
  };

  const handlePrevious = () => {
    setImageId(id - 1);
  };

  return (
    <>
      {isOpen && (
        <div
          id="overlay"
          className="fixed inset-0 flex items-center justify-center bg-opacity-50 z-[1000]"
          style={{ background: "rgba(0, 0, 0, 0.2)" }}
          onClick={handleClose}
        >
          <RxCross2
            onClick={handleCloseModal}
            className="absolute w-7 h-7 bg-black text-white cursor-pointer top-[10%] rounded-full right-[4%]"
          />
          {images && (
            <div className="flex flex-row gap-5 w-[80px]  h-[40px] absolute bottom-[10%] right-auto">
              {id > 0 && (
                <FaArrowAltCircleLeft
                  className="h-[30px] w-[30px] cursor-pointer bg-white rounded-full"
                  onClick={handlePrevious}
                />
              )}
              {id !== images?.length - 1 && (
                <FaArrowAltCircleRight
                  className="h-[30px] w-[30px] bg-white rounded-full cursor-pointer"
                  onClick={handleNext}
                />
              )}
            </div>
          )}

          <div className="z-[1001] relative w-[300px] rounded-lg h-[280px] sm:w-[700px] sm:h-[550px]">
            <img
              src={images[id] ?? url} // Use formatted embed URL
              alt="id"
              className="h-full w-full rounded-lg  object-contain"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ViewImageModal;
